import { backend, isLocalMode } from '../data/backend.js';
import { toast } from './toast.js';

/**
 * Konto-Dialog. Ohne Server (VITE_API_BASE leer) wird nur ein lokales Profil
 * angelegt – damit sind Favoriten pro Profil getrennt, aber nur auf diesem
 * Gerät. Mit Server läuft echtes Login über E-Mail und Passwort.
 */
export function createAccount({ button, onChange }) {
  const dialog = document.getElementById('account-dialog');
  const form = document.getElementById('account-form');
  const title = document.getElementById('account-title');
  const note = document.getElementById('account-note');
  const idLabel = document.getElementById('account-id-label');
  const idInput = document.getElementById('account-id');
  const pwField = document.getElementById('account-pw-field');
  const pwInput = document.getElementById('account-pw');
  const errorEl = document.getElementById('account-error');
  const cancelBtn = document.getElementById('account-cancel');

  let profile = null;
  let mode = 'login'; // oder 'register' (nur mit Server)

  const switchLink = document.createElement('button');
  switchLink.type = 'button';
  switchLink.className = 'linkbtn';
  switchLink.style.marginRight = 'auto';
  switchLink.hidden = isLocalMode;
  switchLink.addEventListener('click', () => {
    mode = mode === 'login' ? 'register' : 'login';
    paintDialog();
  });
  document.querySelector('.dialog__actions')?.prepend(switchLink);

  function paintButton() {
    const label = profile ? profile.name : 'Anmelden';
    const text = button.querySelector('.navbtn__text');
    if (text) text.textContent = label;
    else button.textContent = label;
    button.title = profile ? `${profile.name} – abmelden` : 'Profil anlegen oder anmelden';
    button.setAttribute('aria-label', button.title);
  }

  function paintDialog() {
    errorEl.hidden = true;
    if (isLocalMode) {
      title.textContent = 'Lokales Profil';
      note.textContent =
        'Noch kein Server verbunden: das Profil und die Favoriten bleiben in diesem Browser.';
      idLabel.textContent = 'Profilname';
      idInput.type = 'text';
      idInput.autocomplete = 'username';
      pwField.hidden = true;
      pwInput.required = false;
    } else {
      title.textContent = mode === 'login' ? 'Anmelden' : 'Konto erstellen';
      note.textContent =
        mode === 'login'
          ? 'Mit E-Mail und Passwort anmelden; Favoriten liegen dann auf dem Server.'
          : 'Neues Konto anlegen – Favoriten sind danach auf allen Geräten verfügbar.';
      idLabel.textContent = 'E-Mail';
      idInput.type = 'email';
      idInput.autocomplete = 'email';
      pwField.hidden = false;
      pwInput.required = true;
      switchLink.textContent = mode === 'login' ? 'Konto erstellen' : 'Zurück zum Login';
    }
  }

  async function restore() {
    try {
      profile = await backend.auth.getSession();
    } catch {
      profile = null;
    }
    paintButton();
    onChange?.(profile);
    return profile;
  }

  async function logout() {
    await backend.auth.logout();
    profile = null;
    paintButton();
    onChange?.(profile);
    toast('Abgemeldet.');
  }

  button.addEventListener('click', () => {
    if (profile) return logout();
    paintDialog();
    idInput.value = '';
    pwInput.value = '';
    dialog.showModal();
    idInput.focus();
  });

  cancelBtn.addEventListener('click', () => dialog.close());

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    errorEl.hidden = true;
    try {
      profile = isLocalMode
        ? await backend.auth.login(idInput.value)
        : mode === 'login'
          ? await backend.auth.login(idInput.value, pwInput.value)
          : await backend.auth.register(idInput.value, pwInput.value, idInput.value);
      if (!profile) throw new Error('Anmeldung fehlgeschlagen.');
      dialog.close();
      paintButton();
      onChange?.(profile);
      toast(`Angemeldet als ${profile.name}.`);
    } catch (err) {
      errorEl.textContent = err.message || 'Hat nicht geklappt.';
      errorEl.hidden = false;
    }
  });

  return { restore, getProfile: () => profile, logout };
}
